module.exports = __webpack_public_path__ + "media/site_templates/www.fixholeinwall.com.au/images/our_services_3-7b64d5fa6286027944e846012b786b1d.jpg";